import React, { useState, useEffect } from 'react';
import review1 from '../assets/review/1.png';
import review2 from '../assets/review/2.png';
import review3 from '../assets/review/3.png';
import review4 from '../assets/review/4.png';
import review5 from '../assets/review/5.png';
import review6 from '../assets/review/6.png';
import review7 from '../assets/review/7.png';
import review8 from '../assets/review/8.png';

export default function Reviews(){
    
    const reviews = [
        {
            id: 1,
            image: review1,
            name: "María González",
            country: "España",
            rating: 5,
            text: "¡Excelente calidad de imagen y sonido! Todos los canales españoles funcionan perfectamente. La guía de programación es muy útil para ver qué hay en los canales nacionales. Definitivamente recomendado para cualquiera que busque calidad IPTV."
        },
        {
            id: 2,
            image: review2,
            name: "Carlos Rodríguez",
            country: "España", 
            rating: 5,
            text: "Los canales regionales como TV3, Canal Sur y Telemadrid funcionan perfectamente. También están disponibles los canales de noticias locales, lo que me mantiene siempre informado de las noticias de mi región."
        },
        {
            id: 3,
            image: review3,
            name: "Ana Martín",
            country: "España",
            rating: 5,
            text: "La calidad de los canales españoles como RTVE y Antena 3 es excelente. Imagen y sonido perfectos, sin interrupciones durante la visualización. Finalmente puedo ver todos mis programas favoritos en HD."
        },
        {
            id: 4,
            image: review4,
            name: "David López",
            country: "España",
            rating: 5,
            text: "Servicio increíble con más de 95,000 canales. La instalación fue muy fácil y el soporte al cliente es excepcional. Recomiendo este servicio a todos los amantes de la televisión."
        },
        {
            id: 5,
            image: review5,
            name: "Laura Sánchez",
            country: "España",
            rating: 5,
            text: "Los canales de deportes en HD son impresionantes. Puedo ver todos los partidos de fútbol y otros deportes sin problemas. La conexión es estable y rápida."
        },
        {
            id: 6,
            image: review6,
            name: "Javier Pérez",
            country: "España",
            rating: 5,
            text: "Perfecto para toda la familia. Los niños pueden ver sus programas favoritos y nosotros disfrutamos de películas y series. La variedad de contenido es impresionante."
        },
        {
            id: 7,
            image: review7,
            name: "Isabel García",
            country: "España",
            rating: 5,
            text: "La calidad 4K es espectacular. Nunca había visto la televisión con tanta claridad. El servicio es confiable y vale cada euro invertido."
        },
        {
            id: 8,
            image: review8,
            name: "Miguel Torres",
            country: "España",
            rating: 5,
            text: "Excelente relación calidad-precio. Tienes acceso a miles de canales por una fracción del costo de la televisión tradicional. Muy satisfecho con la compra."
        }
    ];
    const [currentReviewIndex, setCurrentReviewIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            if (!isTransitioning) {
                setIsTransitioning(true);
                setTimeout(() => {
                    setCurrentReviewIndex((prevIndex) => 
                        prevIndex === reviews.length - 1 ? 0 : prevIndex + 1
                    );
                    setTimeout(() => {
                        setIsTransitioning(false);
                    }, 300); // Wait for fade-in to complete
                }, 300); // Wait for fade-out to complete
            }
        }, 3000);

        return () => clearInterval(interval);
    }, [reviews.length, isTransitioning]);

    // Manual navigation with smooth transitions
    const goToReview = (index) => {
        if (index !== currentReviewIndex && !isTransitioning) {
            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentReviewIndex(index);
                setTimeout(() => {
                    setIsTransitioning(false);
                }, 300);
            }, 300);
        }
    };

    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, index) => (
            <svg
                key={index}
                className={`w-6 h-6 ${index < rating ? 'text-yellow-400' : 'text-gray-500'}`}
                fill="currentColor"
                viewBox="0 0 20 20"
            >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
            </svg>
        ));
    };

   

    return(
        <>
            <section className="py-5 sm:py-12 relative overflow-hidden" id="reviews">
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>

                <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto relative z-10">
                    {/* Header Section */}
                    <div className="text-center mb-12">
                        <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] rounded-full px-4 py-2 mb-6">
                            <div className="flex items-center space-x-1">
                                {renderStars(5)}
                            </div>
                            <span className="text-white font-semibold text-sm">4.9/5</span>
                            <span className="text-white/70">•</span>
                            <span className="text-white/70 text-sm">+1,204 reseñas</span>
                        </div>
                        
                        <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                            Lo que dicen nuestros<br/>
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-400">
                                clientes satisfechos
                            </span>
                        </h1>
                        
                        <p className="text-sm text-gray-600 max-w-3xl mx-auto leading-relaxed">
                            Miles de usuarios confían en nosotros para su entretenimiento. 
                            Descubre sus experiencias reales con nuestro servicio IPTV.
                        </p>
                    </div>

                    {/* Main Review Card */}
                    <div className="relative max-w-4xl mx-auto">
                        <div className="bg-white border border-gray-100 rounded-2xl p-4 sm:p-6 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 relative overflow-hidden">
                            {/* Decorative Elements */}
                            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-[#0a1a5f]/10 to-[#002f9c]/10 rounded-full -translate-y-16 translate-x-16"></div>
                            <div className="absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-[#0d47ff]/10 to-[#1d4ed8]/10 rounded-full translate-y-12 -translate-x-12"></div>
                            
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                                {/* Left Side - Review Content */}
                                <div className="space-y-6">
                                    {/* Rating */}
                                    <div className="flex items-center space-x-2">
                                        <div className="flex items-center space-x-1">
                                            {renderStars(reviews[currentReviewIndex].rating)}
                                        </div>
                                        <span className="text-yellow-400 font-bold text-base">5.0</span>
                                    </div>
                                    
                                    {/* Review Text */}
                                    <blockquote className={`text-base text-gray-600 leading-relaxed transition-all duration-700 ease-in-out transform ${
                                        isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'
                                    }`}>
                                        "{reviews[currentReviewIndex].text}"
                                    </blockquote>
                                    
                                    {/* Reviewer Info */}
                                    <div className={`flex items-center space-x-4 transition-all duration-700 ease-in-out transform ${
                                        isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'
                                    }`}>
                                        <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] p-0.5">
                                            <div className="w-full h-full rounded-full bg-white flex items-center justify-center shadow-lg">
                                                <span className="text-gray-800 font-bold text-sm">
                                                    {reviews[currentReviewIndex].name.charAt(0)}
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <p className="text-gray-800 font-bold text-lg">
                                                {reviews[currentReviewIndex].name}
                                            </p>
                                            <p className="text-gray-600 text-sm">
                                                {reviews[currentReviewIndex].country}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Right Side - Screenshot */}
                                <div className="relative">
                                    <div className="relative rounded-2xl overflow-hidden shadow-lg">
                                        <img 
                                            src={reviews[currentReviewIndex].image} 
                                            alt="Captura del Servicio IPTV"
                                            className={`w-full h-64 lg:h-80 object-cover transition-all duration-700 ease-in-out transform ${
                                                isTransitioning ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
                                            }`}
                                        />
                                        {/* Gradient Overlay */}
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Navigation Dots */}
                        <div className="flex justify-center items-center space-x-2 mt-6">
                            {reviews.map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => goToReview(index)}
                                    className={`w-3 h-3 rounded-full transition-all duration-500 ease-in-out transform hover:scale-125 ${
                                        index === currentReviewIndex 
                                            ? 'bg-gradient-to-r from-[#0a1a5f] to-[#002f9c] scale-125 shadow-lg' 
                                            : 'bg-gray-300 hover:bg-gray-400 hover:scale-110'
                                    }`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}